import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "pharmalify-cookie-consent-v1";

type Consent = "accepted" | "essential" | null;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY) as Consent;
      if (!v) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (value: Exclude<Consent, null>) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
    // Signal to analytics loader (deferred GA4) — listeners can re-evaluate.
    window.dispatchEvent(new CustomEvent("pharmalify:consent", { detail: value }));
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed inset-x-3 bottom-3 z-[100] md:inset-x-auto md:right-4 md:bottom-4 md:max-w-md rounded-lg border border-border bg-card shadow-xl p-4 text-sm"
    >
      <p className="text-foreground font-semibold mb-1">Cookies on pharmalify.com</p>
      <p className="text-muted-foreground text-xs leading-relaxed mb-3">
        We use strictly necessary cookies to run the site and, with your consent, anonymized analytics to improve it.
        No advertising cookies. See our{" "}
        <Link to="/privacy" className="underline hover:text-accent">Privacy Policy</Link>.
      </p>
      <div className="flex gap-2 justify-end">
        <Button size="sm" variant="ghost" onClick={() => persist("essential")}>
          Essential only
        </Button>
        <Button size="sm" className="bg-accent hover:bg-accent/90 text-accent-foreground" onClick={() => persist("accepted")}>
          Accept all
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
